module.exports = __webpack_public_path__ + "static/media/esserbella.6cd44433.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/customers/esserbella.png
// module id = 126
// module chunks = 0